import { generateFullName } from 'utils/generateFullNameUtils';

export const ChangeCaseUserData = (data) =>
  data.map((v) => ({
    ...v,
    label: generateFullName(v),
  }));
